import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { RelationCountAttribute } from "./RelationCountAttribute";
export var RelationCountMetadataToAttributeTransformer = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function RelationCountMetadataToAttributeTransformer(expressionMap) {
    _classCallCheck(this, RelationCountMetadataToAttributeTransformer);
    this.expressionMap = expressionMap;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  _createClass(RelationCountMetadataToAttributeTransformer, [{
    key: "transform",
    value: function transform() {
      var _this = this;
      // by example:
      // post has relation count:
      // @RelationCount(post => post.categories) categoryCount
      // category has relation count
      // @RelationCount(category => category.images) imageCount
      // we load post and join category
      // we expect post.categoryCount and post.category.imageCount to have relation counts
      // first create relation count attributes for all relation count metadatas of the main selected object (post from example)
      if (this.expressionMap.mainAlias) {
        this.expressionMap.mainAlias.metadata.relationCounts.forEach(function (relationCount) {
          var attribute = _this.metadataToAttribute(_this.expressionMap.mainAlias.name, relationCount);
          _this.expressionMap.relationCountAttributes.push(attribute);
        });
      }
      // second create relation count attributes for all relation count metadatas of all joined objects (category from example)
      this.expressionMap.joinAttributes.forEach(function (join) {
        // ensure this join has a metadata, because relation count can only work for real orm entities
        if (!join.metadata || join.metadata.isJunction) return;
        join.metadata.relationCounts.forEach(function (relationCount) {
          var attribute = _this.metadataToAttribute(join.alias.name, relationCount);
          _this.expressionMap.relationCountAttributes.push(attribute);
        });
      });
    }
    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------
  }, {
    key: "metadataToAttribute",
    value: function metadataToAttribute(parentAliasName, relationCount) {
      return new RelationCountAttribute(this.expressionMap, {
        relationName: parentAliasName + "." + relationCount.relation.propertyName,
        mapToProperty: parentAliasName + "." + relationCount.propertyName,
        alias: relationCount.alias,
        queryBuilderFactory: relationCount.queryBuilderFactory
      });
    }
  }]);
  return RelationCountMetadataToAttributeTransformer;
}();